module.exports = {"512002001":"莲花街道","512002002":"三贤祠街道","512002003":"资溪街道","512002004":"狮子山街道","512002100":"雁江镇","512002101":"松涛镇","512002102":"宝台镇","512002103":"临江镇","512002104":"保和镇","512002105":"老君镇","512002106":"中和镇","512002107":"丹山镇","512002108":"小院镇","512002109":"堪嘉镇","512002110":"伍隍镇","512002111":"石岭镇","512002112":"东峰镇","512002113":"南津镇","512002114":"忠义镇","512002115":"碑记镇","512002116":"丰裕镇","512002117":"迎接镇","512002118":"祥符镇","512002119":"清水镇","512002200":"新场乡","512002201":"回龙乡","512002400":"四川大堰劳动教养管理所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/512002.json
// module id = 2394
// module chunks = 0